export default "__VITE_ASSET__DNhIG19h__"